import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-card-messages',
    templateUrl: './card-messages.component.html',
    styleUrls: ['./card-messages.component.scss'],
    standalone: false
})

export class CardMessagesComponent {
  @Input() public successMessages: string[] = [];
  @Input() public errorMessages: string[] = [];
  @Input() public warningMessages: string[] = [];
}
